import React from 'react';
import useWorkplacePatient, {
	PatientData,
} from '../../../Hooks/useWorkplacePatient';
import PatientManualRegistrationCzechForm, {
	PatientManualRegistrationCzechFormValues,
} from './PatientManualRegistrationCzechForm';
import { PatientManualRegistrationParams } from '../PatientManualRegistration';
import { useLazyUserParentsQuery } from '../../../../../graphql/graphql';
import useFilters from '../../../../Base/Hooks/useFilters';
import useHelpers from '../../../../Base/Hooks/useHelpers';
import { getMomentDate } from '../../../../../Utils/dates.util';

interface Props {
	workplaceId: string;
	onSuccess?: (params: PatientManualRegistrationParams) => void;
	setIsLoading: (isLoading: boolean) => void;
}
const PatientManualRegistrationCzech: React.FC<Props> = ({
	workplaceId,
	onSuccess,
	setIsLoading,
}) => {
	const { createPatient } = useWorkplacePatient();
	const [getParents] = useLazyUserParentsQuery();
	const { handleDateValue } = useFilters();
	const { handleString } = useHelpers();
	const handleCzechRegistrationSuccess = async (
		values: PatientManualRegistrationCzechFormValues,
		withHealthPlan: boolean,
	) => {
		setIsLoading(true);
		const data: PatientData = {
			sendEmailInvitation: values.sendPatientInviteToMeddi,
			patient: {
				salutationBefore: values.salutationBefore ?? undefined,
				salutationAfter: values.salutationAfter ?? undefined,
				firstName: values.firstName,
				lastName: values.lastName,
				address: values.address,
				insuranceCompanyTermItemId: handleString(
					values.healthInsuranceCompany?.value,
				),
				vzpSupplementaryInsuranceTypeTermItemId: handleString(
					values.vzpSupplementaryInsuranceType?.value,
				),
				contactPhoneNumber: values.phoneNumber ?? undefined,
				contactEmail: values.email,
				insuranceNumber: values.insuranceNumber,
				birthDate: handleDateValue(values.birthDate),
				citizenship: handleString(values.citizenship?.value),
				gender: handleString(values.gender?.value),
			},
			legalRepresentative: values.legalRepresentative ?? undefined,
			healthPlanCode: handleString(values.healthPlanCode?.value),
			healthPlanWorkplaceMemberId:
				values.healthPlanWorkplaceMember?.value ??
				values.healthPlanWorkplaceMember?.id ??
				undefined,
			createdByType: handleString(values.createdByType?.value),
			createdById: values.createdById?.item?.user.id ?? undefined,
			ignoreInsuranceNumberCheck: values.ignoreInsuranceNumberCheck || false,
			capitationRegistrationAt: values.capitationRegistration
				? handleDateValue(values.capitationRegistrationAt)
				: undefined,
		};

		const patient: any = await createPatient(data, workplaceId);
		if (patient && !patient.data.error) {
			let parentId = null;
			if (data.legalRepresentative) {
				const data = await getParents({
					id: patient.data.userId,
				});
				if (data.data?.user?.parents?.[0]?.id) {
					parentId = data.data?.user?.parents?.[0].id;
				}
			}
			if (
				withHealthPlan &&
				patient.data.userId &&
				data.healthPlanCode &&
				data.healthPlanWorkplaceMemberId
			) {
				//@ts-ignore
				window.location.href = `/treatment/default/${patient.data.userId}?handle=createHealthPlan&params%5BhealthPlanCode%5D=${data.healthPlanCode}`;
				return;
			}
			onSuccess?.({
				patientId: patient.data.userId,
				parentId: parentId,
				withInvite: data.sendEmailInvitation,
			});
		}
		setIsLoading(false);
	};

	return (
		<PatientManualRegistrationCzechForm
			onSuccess={handleCzechRegistrationSuccess}
		/>
	);
};

export default PatientManualRegistrationCzech;
